import type { ValuesOf } from '@tmapy/beetlejuice-utils';

export const PUBLISHSET_TYPES = {
  VECTOR: 'VECTOR',
  RASTER: 'RASTER',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PUBLISHSET_TYPES = ValuesOf<typeof PUBLISHSET_TYPES>;

export const PUBLISHSET_STATES = {
  PREPARING: 'PREPARING',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PUBLISHSET_STATES = ValuesOf<typeof PUBLISHSET_STATES>;

export enum PUBLISHSET_FORM_TYPE {
  EDIT = 'EDIT',
  NEW = 'NEW',
}

export const PUBLISHSET_IS_PAID = { TRUE: 'TRUE', FALSE: 'FALSE' } as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PUBLISHSET_IS_PAID = ValuesOf<typeof PUBLISHSET_IS_PAID>;

export const PUBLISHSET_ADMIN_ONLY = { TRUE: 'TRUE', FALSE: 'FALSE' } as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PUBLISHSET_ADMIN_ONLY = ValuesOf<typeof PUBLISHSET_ADMIN_ONLY>;
